<template>
  <label class="w-full">
    <input
      type="text"
      name="text"
      :placeholder="searchPlaceholder"
      class="text-body-sm border-none w-full h-full outline-none text-black"
      :value="modelValue"
      @input="onInput"
      @keydown="onKeydown"
    />
  </label>
</template>

<script setup lang="ts">
type Props = {
  searchPlaceholder: string;
  modelValue: string;
};
defineProps<Props>();
const emit = defineEmits(['update:modelValue', 'keydown']);

const onInput = (event: Event) => {
  const target = event.target as HTMLInputElement;
  emit('update:modelValue', target.value);
};
const onKeydown = (event: KeyboardEvent) => {
  emit('keydown', event);
};
</script>
